import { useMemo } from 'react'
import { useIntl } from 'react-intl'
import MessagingLabel from 'LuxKit/Label/MessagingLabel'
import { sum } from 'lib/array/arrayUtils'

interface Props {
  variants: Array<App.MerchandiseOfferVariant>
}

const MIN_INVENTORY = 5

function MerchandiseLowStockMessage({ variants }: Props) {
  const intl = useIntl()
  const totalInventory = useMemo(
    () => sum(variants.map(variant => variant.inventory ?? 0)),
    [variants],
  )

  if (!totalInventory || totalInventory > MIN_INVENTORY) {
    return null
  }

  return <MessagingLabel variant="urgency">
    {intl.formatMessage(
      {
        id: 'CbGyVjcOfQwex9FZizkf',
        defaultMessage: '{count, plural, one {# left in stock} other {# left in stock}}',
      },
      { count: totalInventory },
    )}
  </MessagingLabel>
}

export default MerchandiseLowStockMessage
